import React from 'react';
import { ctaSection } from '../../data/mock';
import { Button } from '../ui/button';
import { useLanguage } from '../../context/LanguageContext';

const CTASection = () => {
  const { t, language } = useLanguage();
  
  return (
    <section id="contact" className="relative py-20 lg:py-28">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={ctaSection.backgroundImage}
          alt="Fire protection background"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#1a1a1a]/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-montserrat font-black text-white text-3xl sm:text-4xl lg:text-5xl mb-6 leading-tight">
          {language === 'nl' ? (
            <>
              <span>{t('cta.headline')[0]} </span>
              <span className="text-[#e21b1b]">{t('cta.headline')[1]} </span>
              <span>{t('cta.headline')[2]}</span>
              <br />
              <span>{t('cta.headline')[3]}</span>
            </>
          ) : (
            <>
              <span className="text-[#e21b1b]">{t('cta.headline')[0]} </span>
              <span>{t('cta.headline')[1]} </span>
              <span>{t('cta.headline')[2]}</span>
            </>
          )}
        </h2>
        <p className="font-roboto text-gray-300 text-base sm:text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('cta.description')}
        </p>
        <a href="/contact#contact-form">
          <Button
            className="bg-[#e21b1b] hover:bg-[#c41818] text-white font-roboto font-medium tracking-wider px-10 py-6 text-sm uppercase border-2 border-[#e21b1b] hover:border-[#c41818] transition-all duration-300 hover:shadow-lg hover:shadow-[#e21b1b]/30"
          >
            {t('cta.button')}
          </Button>
        </a>
      </div>
    </section>
  );
};

export default CTASection;
